/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuditPlansIndexRouteImport } from './routes/audit-plans/index'
import { Route as AuditPlansPlanIdRouteImport } from './routes/audit-plans/$planId'
import { Route as AssignmentsAssignmentIdRouteImport } from './routes/assignments/$assignmentId'

const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditPlansIndexRoute = AuditPlansIndexRouteImport.update({
  id: '/audit-plans/',
  path: '/audit-plans/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditPlansPlanIdRoute = AuditPlansPlanIdRouteImport.update({
  id: '/audit-plans/$planId',
  path: '/audit-plans/$planId',
  getParentRoute: () => rootRouteImport,
} as any)
const AssignmentsAssignmentIdRoute = AssignmentsAssignmentIdRouteImport.update({
  id: '/assignments/$assignmentId',
  path: '/assignments/$assignmentId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/assignments/$assignmentId': typeof AssignmentsAssignmentIdRoute
  '/audit-plans/$planId': typeof AuditPlansPlanIdRoute
  '/audit-plans': typeof AuditPlansIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/assignments/$assignmentId': typeof AssignmentsAssignmentIdRoute
  '/audit-plans/$planId': typeof AuditPlansPlanIdRoute
  '/audit-plans': typeof AuditPlansIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/assignments/$assignmentId': typeof AssignmentsAssignmentIdRoute
  '/audit-plans/$planId': typeof AuditPlansPlanIdRoute
  '/audit-plans/': typeof AuditPlansIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/assignments/$assignmentId'
    | '/audit-plans/$planId'
    | '/audit-plans'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/assignments/$assignmentId'
    | '/audit-plans/$planId'
    | '/audit-plans'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/assignments/$assignmentId'
    | '/audit-plans/$planId'
    | '/audit-plans/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRoute
  AssignmentsAssignmentIdRoute: typeof AssignmentsAssignmentIdRoute
  AuditPlansPlanIdRoute: typeof AuditPlansPlanIdRoute
  AuditPlansIndexRoute: typeof AuditPlansIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-plans/': {
      id: '/audit-plans/'
      path: '/audit-plans'
      fullPath: '/audit-plans'
      preLoaderRoute: typeof AuditPlansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-plans/$planId': {
      id: '/audit-plans/$planId'
      path: '/audit-plans/$planId'
      fullPath: '/audit-plans/$planId'
      preLoaderRoute: typeof AuditPlansPlanIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assignments/$assignmentId': {
      id: '/assignments/$assignmentId'
      path: '/assignments/$assignmentId'
      fullPath: '/assignments/$assignmentId'
      preLoaderRoute: typeof AssignmentsAssignmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  AssignmentsAssignmentIdRoute: AssignmentsAssignmentIdRoute,
  AuditPlansPlanIdRoute: AuditPlansPlanIdRoute,
  AuditPlansIndexRoute: AuditPlansIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
